import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import RankingCell from "../RankingCell";
import { IonButton, IonIcon } from "@ionic/react";
import { warningSharp } from "ionicons/icons";

interface Props {
  data: any,
  handleSave:any,
  name?:string
}

const DegreeDaysRegressionTable: React.FC<Props> = ({
  data, handleSave, name
}) => {
  function roundToThree(num:any) {
    if(!num){
      return num
    }
    return Math.round((num + Number.EPSILON) * 1000)/1000;
}


  const columns = [
    {
      id:'select',
      header: "",
      cell: (props: any) => {
        if('uuid' in props.row.original)
        {
          return ''
        }
        return (
          <IonButton size="small" color="medium" onClick={()=>handleSave(props)}>Select</IonButton>
        );
      },
      size: 100,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "regression",
      header: "Ranking",
      cell: RankingCell,
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "baseload_coefficient",
      header: "Baseload Coefficient",
      cell: (props: any) => (
        <div className="center-all">{roundToThree(props.getValue())}</div>
      ),
      size: 175,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "HDD_base_temp",
      header: "Base Temp (HDD)",
      cell: (props: any) => (
        <div className="center-all">{props.getValue()}</div>
      ),
      size: 175,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "HDD_coef",
      header: "HDD Coefficient",
      cell: (props: any) => (
        <div className="center-all">{roundToThree(props.getValue())}</div>
      ),
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "CDD_base_temp",
      header: "Base Temp (CDD)",
      cell: (props: any) => (
        <div className="center-all">{props.getValue()}</div>
      ),
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "CDD_coef",
      header: "CDD Coefficient",
      cell: (props: any) => (
        <div className="center-all">{roundToThree(props.getValue())}</div>
      ),
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "rSquared",
      header: "R - Squared",
      cell: (props: any) => (
        <div className="center-all">{roundToThree(props.getValue())}</div>
      ),
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "adjustedRSquared",
      header: "Adjusted R - Squared",
      cell: (props: any) => (
        <div className="center-all">{roundToThree(props.getValue())}</div>
      ),
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "crossValidatedRSquared",
      header: "Cross Validated R - Squared",
      cell: (props: any) => (
        <div className="center-all">{roundToThree(props.getValue())}</div>
      ),
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "standardError",
      header: "Standard Error",
      cell: (props: any) => (
        <div className="center-all">{roundToThree(props.getValue())}</div>
      ),
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      accessorKey: "cvrmse",
      header: "Coefficient of Variation of the Root Mean Square Error",
      cell: (props: any) => (
        <div className="center-all">{roundToThree(props.getValue())}</div>
      ),
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    }
  ];

  const table = useReactTable({
    data: data ? data['regressions'] : [],
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
    columnResizeMode: "onChange",
  });

  if (!data || data['regressions'].length <= 0) {
    return null;
  }

  return (
    <div>
      <div>
          <div style={{display:'flex',justifyContent:'space-between'}}>
            <h3> Regression Analysis Results ({name})</h3>
          </div>
        </div>
        { data && data['regressions'].length > 0 ? <div style={{textAlign:'center',display:'flex',justifyContent:'center'}}>
        <IonIcon src={warningSharp} size="large"></IonIcon>
        <span style={{fontWeight:'bold', display:'flex', textAlign:'center', alignItems:'center', marginLeft:'0.3rem', marginRight:'0.3rem'}}>The Coefficient of Variation of the Root Mean Square Error should not be ABOVE 0.2 and be careful with Negative Coefficients.</span>
        <IonIcon src={warningSharp} size="large"></IonIcon>
      </div> : null}
      <div style={{textAlign:"center", padding:'0.5rem'}}>
        <div>Results are shown in order based on ranking.</div>
        <div>
          Press the select button next to the one you want to save for that meter.
        </div></div>
        <div style={{display:'flex',justifyContent:'center'}}>
      <div
        className="stories-table"
        style={{ width: table.getTotalSize(), marginBottom: "2em", overflowX: "auto" }}
      >      
        {table.getHeaderGroups().map((headerGroup: any) => (
          <div key={headerGroup.id} className="tr">
            {headerGroup.headers.map((header: any) => {
              return (
                <div
                  key={header.id}
                  className="th"
                  style={{ width: header.getSize() }}

                >
                  {header.column.columnDef.header}
                  <div
                    onMouseDown={header.getResizeHandler()}
                    onTouchStart={header.getResizeHandler()}
                    className={`resizer ${
                      header.column.getIsResizing() ? "isResizing" : ""
                    }`}
                  ></div>
                </div>
              );
            })}
          </div>
        ))}
        {table.getRowModel().rows.map((row: any) => (
          <div
            key={row.id}
            className="tr"
            style={{ width: table.getTotalSize() }}
          >
            {row.getVisibleCells().map((cell: any) => {
              return (
                <div
                  key={cell.id}
                  className="td"
                  style={{ width: cell.column.getSize() }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              );
            })}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default DegreeDaysRegressionTable;
